import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MessengerService } from 'src/app/account/services/messenger.service';
import { Subscription } from 'rxjs';
import { StoreMode } from 'src/app/core/enums';
import { UserService } from 'src/app/core/user/user.service';
import { MessengerLinkRequest } from 'src/app/core/models/MessengerLinkRequest';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { SetCode } from 'src/app/core/enums/SetCode';
import { LoginMethod } from 'src/app/core/enums/loginMethod';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whatsapp-authentication',
  templateUrl: './whatsapp-authentication.component.html',
  styleUrls: ['./whatsapp-authentication.component.scss']
})
export class WhatsappAuthenticationComponent implements OnInit, OnDestroy {
  @Input() accessCode: any;
  @Input() whatsappEnquiryParam: string = '';
  @Input() isHideContinueAsGuest: boolean = true;
  @Input() outletImage: string = null;
  @Input() modalHeader: string = 'desc.let.get.start';
  @Input() modalDesc: string = 'desc.choose.a.secure.way.to.continue';
  @Output() onClickClose = new EventEmitter();
  @Output() onSuccessClose = new EventEmitter();
  @Output() onMobileNoLogin = new EventEmitter();
  @Output() onShowFail = new EventEmitter<boolean>();
  @Output() isOnReload = new EventEmitter<boolean>();

  logo: string = null;
  WhatsappLoginResponse: boolean = false;
  intervalId: any;
  getWhatsappLoginStatus$: Subscription;
  getWhatsappLoginPollingStatus$: Subscription;
  showSuccess: boolean = false;
  showFail: boolean = false;
  curUser: any;
  sub: Subscription = new Subscription();
  name: any;
  channelSub$: Subscription;
  getLoginMethodList: string[] = [];
  loginMethod: any[] = [];

  constructor(
    private messengerService: MessengerService,
    private userService: UserService,
    private channelService: ChannelService,
    private sessionStorageService: SessionStorageService,
    private previousRouterService: PreviousRouteService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }


  async ngOnInit(): Promise<void> {
    await this.channelService.getChannelDataCheck();

    this.channelSub$ = this.channelService.get(StoreMode.Internal).subscribe((dt) => {
      if (dt) {
        let platformSets = dt.data.platformSets.find(setting => setting.setCode == SetCode.LOGINMETHOD)?.setValue;

        if (platformSets) {
          this.getLoginMethodList = JSON.parse(platformSets);
          this.generateLoginList(this.getLoginMethodList);
        }

        if (this.outletImage && this.outletImage.trim() !== '') {
          this.logo = this.outletImage;
        } else if (dt.data?.imageLink && dt.data?.imageLink.trim() !== '') {
          this.logo = dt.data.imageLink;
        }
      }
    });
  }

  generateLoginList(getLoginMethodList: string[]) {
    this.loginMethod = [];

    if (getLoginMethodList.includes(LoginMethod.WA)) {
      this.loginMethod.push({
        name: 'label.continue.with.whatsapp',
        icon: 'icon-whatsapp',
        stylingClass: 'whatsappLogin-btn',
        onClick: () => this.onClickWhatsappLogin(),
      })
    }

    if (getLoginMethodList.includes(LoginMethod.MN)) {
      this.loginMethod.push({
        name: 'label.continue.with.mobile.number',
        icon: 'icon-whatsapp',
        stylingClass: 'mobileLogin-btn',
        isBorderButton: true,
        onClick: () => this.onClickNormalLogin(),
      })
    }

    if (!this.isHideContinueAsGuest) {
      this.loginMethod.push({
        name: 'button.continue.as.guest',
        stylingClass: 'continueAsGuest-btn',
        isBlackTextButton: true,
        onClick: () => this.onContinueAsGuest(),
      })
    }
  }

  onClickNormalLogin() {
    this.onMobileNoLogin.emit();
    this.onClickClose.emit();
  }

  async onClickWhatsappLogin() {
    let messengerLinkRequest = {} as MessengerLinkRequest;
    messengerLinkRequest.templateCode = 'GenAcsCode';
    messengerLinkRequest.sender = '';
    messengerLinkRequest.msgParamsData = {
      '{entrypoint}': this.whatsappEnquiryParam,
    }

    if (this.whatsappEnquiryParam == 'cart') {
      this.previousRouterService.savedPaymentBackUrl(this.router.url);
    }
    let resp: any = await this.messengerService.generateMessenger(messengerLinkRequest);

    if (resp instanceof (HttpErrorResponse)) {
      this.showFail = true;
    } else {
      this.accessCode = resp[0].otpCode;
      const isIOS = /iP(hone|od|ad)/.test(navigator.userAgent);
      if (isIOS) {
        window.location.assign(resp[0].messageLink);
      } else {
        window.open(resp[0].messageLink, '_blank', 'noopener');
      }
      this.WhatsappLoginResponse = true;
      if (isPlatformBrowser(this.platformId)) {
        this.intervalId = setInterval(async () => { this.onTimerRefresh(resp[0].messageKey) }, 5000);
      }
    }
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  onClose() {
    this.onClickClose.emit();
    this.stopInterval();
    this.resetWhatsappLoginResponse();
    if (this.sessionStorageService.getItem('openJoinMembershipDialog')) {
      this.sessionStorageService.removeItem("openJoinMembershipDialog");
    }

    this.sessionStorageService.removePaymentAndConfirmOrder();
  }

  onClickSuccessClose() {
    this.onSuccessClose.emit();
    this.stopInterval();
    this.resetWhatsappLoginResponse();
  }

  async onTimerRefresh(messageKey: string) {
    await this.messengerService.getmessagestatus(messageKey);

    this.getWhatsappLoginPollingStatus$ = this.messengerService.getWhatsappStatus().subscribe((dt: any) => {
      if (dt && dt?.isFail && dt?.isFail === true) {
        this.showFail = dt.isFail;
        this.onShowFail.emit(true);
        this.stopInterval();
      }
    });

    this.getWhatsappLoginStatus$ = this.messengerService.getWhatsappLoginStatus().subscribe((dt: any) => {
      this.showSuccess = dt && dt.isSuccess;

      if (dt && dt?.isSuccess && dt?.isSuccess === true) {
        this.showSuccess = dt.isSuccess;
        this.isOnReload.emit(true);
        this.stopInterval();

        this.sub = this.userService.get(StoreMode.Internal).subscribe((dt: any) => {
          this.curUser = dt ? dt : null;
          if (this.curUser) {
            this.name = this.curUser.name ?? 'user';
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.getWhatsappLoginPollingStatus$?.unsubscribe();
    this.getWhatsappLoginStatus$?.unsubscribe();
    this.channelSub$?.unsubscribe();
  }

  onRetryLogin() {
    this.resetWhatsappLoginResponse();
  }

  resetWhatsappLoginResponse() {
    this.WhatsappLoginResponse = false;
    this.showSuccess = false;
    this.showFail = false;
    this.onShowFail.emit(false);

    this.messengerService.showFailLogin.next({
      isFail: false,
    });

    this.messengerService.showSuccessLogin.next({
      isSuccess: false
    });
  }

  onContinueAsGuest() {
    this.onClose()
  }
}
